<div class="page">
    <div class="kpi-row">
        <div class="kpi-panel">
            <span class="kpi-panel-title">{{ currentMonthLabel }}</span>
            <div class="kpi-panel-body">
                @for (stat of monthlyStats; track stat.label) {
                    <div class="kpi-tile">
                        <span class="kpi-label">{{ stat.label }}</span>
                        <span class="kpi-value">{{ stat.value }}</span>
                    </div>
                }
            </div>
        </div>

        <div class="kpi-panel">
            <span class="kpi-panel-title">Outstanding</span>
            <div class="kpi-panel-body">
                @for (stat of outstandingStats; track stat.label) {
                    <div class="kpi-tile">
                        <span class="kpi-label">{{ stat.label }}</span>
                        <span class="kpi-value">{{ stat.value }}</span>
                    </div>
                }
            </div>
        </div>
    </div>

    <div class="page-header">
        <h1 class="page-title">Reporting</h1>
    </div>

    <div class="filter-bar">
        <p-select
            [options]="reportViewOptions"
            [ngModel]="reportView()"
            (ngModelChange)="reportView.set($event)"
            optionLabel="label"
            [showClear]="false"
            styleClass="filter-select"></p-select>

        <input
            pInputText
            type="text"
            [ngModel]="searchTerm()"
            (ngModelChange)="searchTerm.set($event)"
            placeholder="Search"
            class="filter-search" />

        <p-select
            [options]="clientOptions()"
            [ngModel]="selectedClient()"
            (ngModelChange)="selectedClient.set($event)"
            optionLabel="label"
            placeholder="Client"
            styleClass="filter-select"></p-select>

        <p-datepicker
            [ngModel]="startDate()"
            (ngModelChange)="startDate.set($event)"
            placeholder="Start Date"
            [iconDisplay]="'input'"
            [showIcon]="true"
            styleClass="filter-datepicker"></p-datepicker>

        <p-datepicker
            [ngModel]="endDate()"
            (ngModelChange)="endDate.set($event)"
            placeholder="End Date"
            [iconDisplay]="'input'"
            [showIcon]="true"
            styleClass="filter-datepicker"></p-datepicker>

        <p-button
            icon="pi pi-filter-slash"
            severity="secondary"
            size="small"
            [outlined]="true"
            (onClick)="onResetFilters()"
            pTooltip="Clear all filters"
            tooltipPosition="bottom"></p-button>

        <p-button
            label="Download Tickets Metrics"
            icon="pi pi-file-excel"
            [styleClass]="'embark-bg-blue'"
            [loading]="isInvoiceMetricsLoading()"
            (onClick)="onDownloadInvoiceMetrics()"></p-button>

        <p-button
            label="Download SO Pending Billing"
            icon="pi pi-file"
            [styleClass]="'embark-bg-blue'"
            [loading]="isSoPendingBillingLoading()"
            (onClick)="onDownloadSoPendingBilling()"></p-button>

        <p-button
            label="Download"
            [styleClass]="'embark-bg-blue'"
            [loading]="isDownloadLoading()"
            (onClick)="onDownload()"></p-button>
    </div>

    <div class="report-table">
        <p-table
            [value]="filteredReportData()"
            [selection]="selectedRows()"
            (selectionChange)="onSelectionChange($event)"
            [selectAll]="allSelected()"
            (selectAllChange)="onSelectAllChange($event)"
            [first]="tableFirst()"
            (onPage)="onPageChange($event)"
            dataKey="id"
            [loading]="isReportTableLoading"
            [scrollable]="true"
            [paginator]="true"
            [rows]="25"
            [rowsPerPageOptions]="[25, 50, 100]"
            [resizableColumns]="true">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 40px; text-align: center">
                        <p-tableHeaderCheckbox />
                    </th>
                    @for (col of reportColumns(); track col.field) {
                        <th
                            [pSortableColumn]="col.field"
                            [class.fixed-width-column]="isFixedWidthColumn(col.field)">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" />
                        </th>
                    }
                </tr>
            </ng-template>
            <ng-template
                let-row
                pTemplate="body">
                <tr>
                    <td style="text-align: center">
                        <p-tableCheckbox [value]="row" />
                    </td>
                    @for (col of reportColumns(); track col.field) {
                        <td
                            [class.fixed-width-column]="isFixedWidthColumn(col.field)"
                            [title]="isFixedWidthColumn(col.field) ? row[col.field] : null">
                            {{ row[col.field] }}
                        </td>
                    }
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="reportColumns().length + 1">No data available.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorright">
                <span class="total-records">Total Records: {{ filteredReportData().length }}</span>
            </ng-template>
        </p-table>
    </div>
</div>
